import 'whatwg-fetch';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { API_ROOT } from 'signoxe/constants/config';
import { CONTENT_FEEDS_RESOURCE, DEVICE_GROUPS_RESOURCE, DEVICES_RESOURCE } from "signoxe/api/resources";
import { getAuthTokenHeader } from "signoxe/actions/remote";
import { confirmationRequest, fetchDeviceGroups, fetchSingleDeviceGroups,  downloadReport, toggleDeviceId, updateDeviceGroup } from "signoxe/actions";
import {
  ContentFeedView,
  DeviceView,
  PriorityMessageView,
  ScheduleSummaryView,
} from 'signoxe/components';
import Dropdown, { DropdownContent, DropdownTrigger } from 'react-simple-dropdown';
import { Box } from 'signoxe/components/layout';
import { EditableLabel, HoverView, Icon, Switch } from 'signoxe/components/widgets';
import './styles.scss';
import { connect } from "react-redux";
import { getProfile } from "signoxe/selectors";
import * as _ from "lodash";
import {Popup} from 'signoxe/components/widgets';

class DeviceGroupView extends Component {
  constructor(props) {
    super(props);

    let syncPeriodicityValue = 0;
    let syncPeriodicityMultiplier = 60;
    const deviceGroup = this.props.deviceGroup;
    const syncPeriodSeconds = (deviceGroup.feed && deviceGroup.feed.group_sync_period_seconds) || 0;
    if (syncPeriodSeconds > 0) {
      let remainder = syncPeriodSeconds % 3600;
      if (remainder > 0) {
        syncPeriodicityValue = Math.floor(syncPeriodSeconds / 60);
        syncPeriodicityMultiplier = 60;
      } else {
        syncPeriodicityValue = Math.floor(syncPeriodSeconds / 3600);
        syncPeriodicityMultiplier = 3600;
      }
    }

    // Fetch rowNumber from local storage
    const localStorageKey = `${deviceGroup.name}_rowNumber`;
    const storedRowNumber = localStorage.getItem(localStorageKey);
    let rowNumber = 5; // Default value

    // Check if storedRowNumber is not null and is a number
    if (storedRowNumber !== null && !isNaN(storedRowNumber)) {
      rowNumber = parseInt(storedRowNumber, 10);
    }

    this.state = {
      showPriorityMessage: false,
      syncPeriodicityValue,
      syncPeriodicityMultiplier,
      showDevices: true,
      devices: this.props.deviceGroup.devices,
      searchInput: '',
      filteredResults: [],
      showSearchBox: false,
      pageNumber: 1,
      rowNumber,
      showDeviceInfo:false,
      deviceSelected:[],
    };
  }

  

  static propTypes = {
    deviceGroup: PropTypes.object.isRequired,
    screenshotsEnabled: PropTypes.bool,
    deviceReportEnabled: PropTypes.bool,
    rebootEnabled: PropTypes.bool,
    RestartAppEnabled: PropTypes.bool,
    ClearUnusedMediaEnabled: PropTypes.bool,
    offlineEnabled: PropTypes.bool,
    delayDownloadEnabled: PropTypes.bool,
    smartBoardEnabled: PropTypes.bool,
    downloadReport: PropTypes.func.isRequired,
    groupList: PropTypes.array.isRequired,
    onDeviceChange: PropTypes.func.isRequired,
    onGroupFeedChange: PropTypes.func.isRequired,
    onDeviceGroupDelete: PropTypes.func.isRequired,
    onDeviceGroupChange: PropTypes.func.isRequired,
    onClickSchedule: PropTypes.func.isRequired,
    onPriorityMessageChange: PropTypes.func.isRequired,
    onPriorityMessageDeactivate: PropTypes.func.isRequired,
    onPriorityMessageActivate: PropTypes.func.isRequired,
    searchString: PropTypes.string.isRequired,
    deviceTags: PropTypes.object,
  };

  searchItems = (searchValue) => {
      this.setState({ searchInput: searchValue });
      const searchInputLower = searchValue.toLowerCase();

      if (searchInputLower !== '') {
          const tagMap = new Map();
          // Create a map for tagId to tagName for quick lookup
          this.props.deviceTags.forEach(tag => {
              tagMap.set(tag.id, tag.name.toLowerCase());
          });

          const filteredData = this.state.devices.filter((device) => {
              // Check if device name matches
              const nameMatch = device.name.toLowerCase().includes(searchInputLower);
              
              // Check if any of the device's tags match
              const tagMatch = device.tags.some(tagId => {
                  const tagName = tagMap.get(tagId);
                  return tagName && tagName.includes(searchInputLower);
              });

              return nameMatch || tagMatch;
          });

          this.setState({ filteredResults: filteredData });
      } else {
          this.setState({ filteredResults: this.state.devices });
      }
  }

  handleToggleShowPriorityMessage = () =>
    this.setState({ showPriorityMessage: !this.state.showPriorityMessage })

  configComponent() {
    const { deviceGroup, onGroupFeedChange, onDeviceGroupChange, profile, handleUserReport } = this.props;
    console.log(onDeviceGroupChange)
    return (deviceGroup.schedule.present ||
      (profile && profile.features && profile.features.multichannel ?
        <React.Fragment>
          <Box direction="row"
            alignItems="center"
            className="device-group-config" wrap>
            <ContentFeedView profile={profile} onDeviceGroupChange={onDeviceGroupChange} deviceGroup={deviceGroup} feed={deviceGroup.feed} onChange={onGroupFeedChange} />
          </Box>
          {deviceGroup.feed_chain.filter(feed => feed.id !== deviceGroup.feed.id).map(feed =>
            <Box
              direction="row" alignItems="center" className="device-group-config" wrap
            >
              <ContentFeedView
                 profile={profile} onDeviceGroupChange={onDeviceGroupChange}
                deviceGroup={deviceGroup} feed={feed} onChange={onGroupFeedChange} hideDurations={true} hideOrientationSelection={true}
                hideOverlayTickers={true}
              />
              <Icon name="trash-o" size="1.5rem" title="Remove Feed" onClick={() => this.deleteFeed(feed)} />
            </Box>)}
          <Box direction="row" alignItems="center" className="device-group-config" wrap>
            <Switch checked={deviceGroup.display_date_time}
              formId={`show-time-${deviceGroup.id}`}
              label="Show Time"
              size="large"
              onChange={({ currentTarget }) =>
                onDeviceGroupChange(deviceGroup.id, { display_date_time: currentTarget.checked })
              } />
          </Box>
        </React.Fragment> :
        <Box direction="row"
          alignItems="center"
          className="device-group-config" wrap>
          <ContentFeedView
           profile={profile} onDeviceGroupChange={onDeviceGroupChange}
          deviceGroup={deviceGroup} feed={deviceGroup.feed} onChange={onGroupFeedChange} />
          <Switch checked={deviceGroup.display_date_time}
            formId={`show-time-${deviceGroup.id}`}
            label="Show Time"
            size="large"
            onChange={({ currentTarget }) =>
              onDeviceGroupChange(deviceGroup.id, { display_date_time: currentTarget.checked })
            }
          />
        </Box>
      )
    );
  }

  showText(text) {
    return <span className='show-text'>{text}</span>
  }

  headerComponent() {
    const {
      deviceGroup, onClickSchedule, onDeviceGroupChange, onDeviceGroupDelete, onGroupFeedChange,
      smartBoardEnabled, profile, toggleDeviceId, searchString, devices, 
    } = this.props;

    console.log(onDeviceGroupChange)

    const visible = this.state.showDevices;
    const { showSearchBox } = this.state
    
    const offlineOnly = localStorage.getItem('offlineOnly')
    const self_activation = localStorage.getItem('self_activation')

    return (
      <Box direction="row" justifyContent="space-between" alignItems="center" className="header depth-1 pt-2">
        <h4>
          <EditableLabel value={deviceGroup.name}
            onChange={(newVal) => onDeviceGroupChange(deviceGroup.id, {
              id: deviceGroup.id,
              name: newVal,
            })} />
        </h4>
        {self_activation === 'false' ?
          <div>
            <Icon
              title="Refresh Content"
              name="refresh"
              size="1rem"
              className={`is-cursor`}
              onClick={(e) => {
                onDeviceGroupChange(deviceGroup.id);
                e.currentTarget.style.transition = 'transform 3s linear';
                e.currentTarget.style.transform = 'rotate(360deg)';
                setTimeout(() => {
                  e.currentTarget.style.transition = '';
                  e.currentTarget.style.transform = '';
                }, 3000);
              }}
            />
            <span onClick={() => this.setState({ showSearchBox: !showSearchBox })} className='device-action-icon'>
            
              {this.showText(`${showSearchBox ? 'Searches Devices' : 'Searches Devices'}`)}
              <Icon
                title={showSearchBox ? 'Hide Search' : 'Show Search'}
                name={!showSearchBox ? "search" : "search"}
                size="1rem"

              />
            </span>
            <span onClick={() => toggleDeviceId(deviceGroup.id)} className='device-action-icon'>
              {this.showText('Manage Content')}
              <Icon
                title='Manage Content'
                name="play"
                size="1rem"

              />
            </span>

            <span onClick={() => this.setState({ showDevices: !visible })} className='device-action-icon'>
              {this.showText(`${visible ? 'Hide Devices' : 'Show Devices'}`)}
              <Icon
                title={visible ? 'Hide Devices' : 'Show Devices'}
                name={!visible ? "eye" : "eye-slash"}
                size="1rem"

              />
            </span>
            <Dropdown>

              <DropdownTrigger>
                <span className='device-action-icon'>
                  {this.showText('More Options')}
                  <Icon title="Group options"
                    name="ellipsis-v"
                    size="1.2rem"
                  />
                </span>
              </DropdownTrigger>
              <DropdownContent className="user-menu options-menu card depth-1">


                {smartBoardEnabled &&
                  <li>
                    <Icon name="bullhorn" size="1.5rem" title="Priority Announcement"
                      onClick={this.handleToggleShowPriorityMessage}
                      color={(deviceGroup.priority_message && deviceGroup.priority_message.activated_on)
                        ? 'red'
                        : 'black'} /> </li>}
                <li onClick={() => onClickSchedule(deviceGroup)}>
                  <HoverView hoverView={
                    deviceGroup.schedule.present &&
                    <ScheduleSummaryView schedule={deviceGroup.schedule} specials={deviceGroup.specials} />
                  }>
                    <span>Schedule</span>
                    <Icon title="Schedule"
                      name="calendar-o"
                      size="1rem"
                      color={deviceGroup.schedule.present ? 'green' : undefined}
                      className={classNames({ scheduled: deviceGroup.schedule.present })}
                    />
                  </HoverView>
                </li>
                <li onClick={() => onDeviceGroupDelete(deviceGroup)}>
                  <span style={{ color: '#cc4b37' }}>Delete Group</span> <Icon title="Delete"
                    name="trash-o"
                    size="1rem"
                    color="#cc4b37"
                  />
                </li>

              </DropdownContent>
            </Dropdown>
          
            {/* <span onClick={() => this.setState({ showSearchBox: !showSearchBox })} className='device-action-icon'>
              {this.showText(`${showSearchBox ? 'Search Devices' : 'Search Devices'}`)}
              <Icon
                title={showSearchBox ? 'Hide Search' : 'Show Search'}
                name={!showSearchBox ? "search" : "search"}
                size="1rem"

              />
            </span> */}
          </div>
          :
          offlineOnly === 'false' ?
          <div>
            <Icon
              title="Refresh Content"
              name="refresh"
              size="1rem"
              className={`is-cursor`}
              onClick={(e) => {
                onDeviceGroupChange(deviceGroup.id);
                e.currentTarget.style.transition = 'transform 3s linear';
                e.currentTarget.style.transform = 'rotate(360deg)';
                setTimeout(() => {
                  e.currentTarget.style.transition = '';
                  e.currentTarget.style.transform = '';
                }, 3000);
              }}/>
          <span onClick={() => this.setState({ showSearchBox: !showSearchBox })} className='device-action-icon'>
            {this.showText(`${showSearchBox ? 'Search Devices' : 'Search Devices'}`)}
            <Icon
              title={showSearchBox ? 'Hide Search' : 'Show Search'}
              name={!showSearchBox ? "search" : "search"}
              size="1rem"

            />
          </span>
          <span onClick={() => toggleDeviceId(deviceGroup.id)} className='device-action-icon'>
            {this.showText('Manage Content')}
            <Icon
              title='Manage Content'
              name="play"
              size="1rem"

            />
          </span>

          <span onClick={() => this.setState({ showDevices: !visible })} className='device-action-icon'>
            {this.showText(`${visible ? 'Hide Devices' : 'Show Devices'}`)}
            <Icon
              title={visible ? 'Hide Devices' : 'Show Devices'}
              name={!visible ? "eye" : "eye-slash"}
              size="1rem"

            />
          </span>
          <Dropdown>

            <DropdownTrigger>
              <span className='device-action-icon'>
                {this.showText('More Options')}
                <Icon title="Group options"
                  name="ellipsis-v"
                  size="1.2rem"
                />
              </span>
            </DropdownTrigger>
            <DropdownContent className="user-menu options-menu card depth-1">


              {smartBoardEnabled &&
                <li>
                  <Icon name="bullhorn" size="1.5rem" title="Priority Announcement"
                    onClick={this.handleToggleShowPriorityMessage}
                    color={(deviceGroup.priority_message && deviceGroup.priority_message.activated_on)
                      ? 'red'
                      : 'black'} /> </li>}
              <li onClick={() => onClickSchedule(deviceGroup)}>
                <HoverView hoverView={
                  deviceGroup.schedule.present &&
                  <ScheduleSummaryView schedule={deviceGroup.schedule} specials={deviceGroup.specials} />
                }>
                  <span>Schedule</span>
                  <Icon title="Schedule"
                    name="calendar-o"
                    size="1rem"
                    color={deviceGroup.schedule.present ? 'green' : undefined}
                    className={classNames({ scheduled: deviceGroup.schedule.present })}
                  />
                </HoverView>
              </li>
              <li onClick={() => onDeviceGroupDelete(deviceGroup)}>
                <span style={{ color: '#cc4b37' }}>Delete Group</span> <Icon title="Delete"
                  name="trash-o"
                  size="1rem"
                  color="#cc4b37"
                />
              </li>

            </DropdownContent>
          </Dropdown>
          </div>
          :
          <div>
              <Icon
              title="Refresh Content"
              name="refresh"
              size="1rem"
              className={`is-cursor`}
              onClick={(e) => {
                onDeviceGroupChange(deviceGroup.id);
                e.currentTarget.style.transition = 'transform 3s linear';
                e.currentTarget.style.transform = 'rotate(360deg)';
                setTimeout(() => {
                  e.currentTarget.style.transition = '';
                  e.currentTarget.style.transform = '';
                }, 3000);
              }}
            />
            <span onClick={() => this.setState({ showSearchBox: !showSearchBox })} className='device-action-icon'>
              {this.showText(`${showSearchBox ? 'Search Devices' : 'Search Devices'}`)}
              <Icon
                title={showSearchBox ? 'Hide Search' : 'Show Search'}
                name={!showSearchBox ? "search" : "search"}
                size="1rem"

              />
            </span>
          </div>
        
        }
        

      </Box>);
  }

  priorityMessageComponent() {
    const {
      deviceGroup,
      onPriorityMessageActivate, onPriorityMessageChange, onPriorityMessageDeactivate,
      devices,
    } = this.props;
    const { priority_message } = deviceGroup;
    const activated = priority_message && priority_message.activated_on;

    return ((this.state.showPriorityMessage || activated) &&
      <PriorityMessageView priorityMessage={priority_message}
        onChange={(newMsg) => onPriorityMessageChange(deviceGroup.id, newMsg)}
        onDeactivate={() => onPriorityMessageDeactivate(deviceGroup.id)}
        onActivate={() => onPriorityMessageActivate(deviceGroup.id)} />
    );
  }

  addFeed() {
    const requestOptions = {
      method: 'POST',
      headers: {
        Authorization: getAuthTokenHeader(),
      },
      credentials: 'same-origin',
    };
    return fetch(`${API_ROOT}${DEVICE_GROUPS_RESOURCE}/${this.props.deviceGroup.id}/feeds/`, requestOptions).then(
      response => response.json()
    ).then(feed => this.props.fetchDeviceGroups(this.props.deviceGroup.id));
  }

  deleteFeed(feed) {
    this.props.confirmationRequest(
      'Deleting Content Feed',
      `Deleting the content feed "${feed.title}" is permanent and cannot be undone.`,
      'DELETE',
      CONTENT_FEEDS_RESOURCE,
      feed.id,
    )
  }

  rebootDevice(device) {
    this.props.confirmationRequest(
      'Rebooting Device',
      `Rebooting Device "${device.name}", this action can't be undone.`,
      'REBOOT',
      DEVICES_RESOURCE,
      device.id
    )
  }

  RestartApp(device) {
    this.props.confirmationRequest(
      'Restarting Application',
      `Restarting Application on Device "${device.name}", this action can't be undone.`,
      'RESTART_APP',
      DEVICES_RESOURCE,
      device.id
    )
  }

  ClearUnusedMedia(device) {
    this.props.confirmationRequest(
      'Clearing Unused Media',
      `Clearing Unused Media on Device "${device.name}", this action can't be undone.`,
      'CLEAR_UNUSED_MEDIA',
      DEVICES_RESOURCE,
      device.id
    )
  }

  onCancel = () => {
    this.setState({showDeviceInfo:!this.state.showDeviceInfo})
  };

  ShowDeviceInfo = (device) => {
    this.setState({ deviceSelected: device });
    this.setState((prevState) => ({ showDeviceInfo: !prevState.showDeviceInfo }));
  }

  getCharactersAfterEth0(inputString) {
    const keyword = "eth0";
    const index = inputString.indexOf(keyword);
    if (index !== -1) {
        const startIndex = index + keyword.length;
        return inputString.substr(startIndex, 18);
    } else {
        return "";
    }
}



  render() {
    const { deviceGroup, groupList, onDeviceChange, screenshotsEnabled, downloadReport, groupsOptionData,
      deviceReportEnabled, smartBoardEnabled, offlineEnabled, delayDownloadEnabled, rebootEnabled, RestartAppEnabled, ClearUnusedMediaEnabled, searchString, devices, profile } = this.props;

    const { devices, searchInput, visible, filteredResults, showSearchBox, pageNumber, rowNumber, showDeviceInfo, deviceSelected} = this.state;
    // const iteratees = (device) => device.name == "vote";

    console.log("deviceinfo", devices)
    //Will need to be refactored

    //devices
    const pages = Math.ceil(deviceGroup.devices.length/rowNumber)
    const rowNumbers = () => {
      const rows = Math.ceil(deviceGroup.devices.length/5) * 5
      let options = []
      for(let i = 5; i <= rows; i += 5){
        options.push(
        <option value={i}>
          {i}
        </option>)
      }
      return(
        options
      )
    }

    const handleRows = (event) => {
      const localStorageKey = `${deviceGroup.name}_rowNumber`;

      // Update local storage
      localStorage.setItem(localStorageKey, event.target.value);

      // Update state
      this.setState({ rowNumber: event.target.value });
      this.setState({ pageNumber: 1 })
    }

    let devices = []
    if(pageNumber == 1){
      devices = deviceGroup.devices.slice(0, rowNumber)
    }else{
      devices = deviceGroup.devices.slice(rowNumber * (pageNumber - 1), rowNumber * (pageNumber))
    }

    //filtered devices
    
    const filteredPages = Math.ceil(filteredResults.length/rowNumber)
    const filteredRowNumbers = () => {
      const rows = Math.ceil(filteredResults.length/5) * 5
      let options = []
      for(let i = 5; i <= rows; i += 5){
        options.push(
        <option value={i}>
          {i}
        </option>)
      }
      return(
        options
      )
    }

    console.log("Fpages", filteredPages)

    let filteredDevices = []
    if(pageNumber == 1){
      filteredDevices = filteredResults.slice(0, rowNumber)
    }else{
      filteredDevices = filteredResults.slice(rowNumber * (pageNumber - 1), rowNumber * (pageNumber))
    }

    console.log("FDevices", filteredDevices)
    const offlineOnly = localStorage.getItem('offlineOnly')
    const self_activation = localStorage.getItem('self_activation')

    return (
      <Box direction="column" className="device-group card depth-1">
      
      {showDeviceInfo &&
         <Popup className="text-center" title="Device Infornamtion" modal>
         <p className="pad-1">Device Name: {deviceSelected.name}</p>
         <p>Device ID : {deviceSelected.device_id.substring(deviceSelected.device_id.length - 6)}</p>
         <p>Build version : {deviceSelected.build_version}</p>
         <p>Mac ID : {this.getCharactersAfterEth0(deviceSelected.mac_id)}</p>
      

         <div className="pad-1 text-center pb flex flex-jc-sb">
           <div></div>
           <button className="button" onClick={this.onCancel}>
             Close
           </button>
         </div>
       </Popup>}
        {this.headerComponent()}
        {smartBoardEnabled && this.priorityMessageComponent()}
        {/*this.configComponent()*/}
        <table className="device-list stack unstriped">
          <thead>
            {self_activation === 'false' ? 
              <tr className="list-headings depth-1">
              <th>Device Name</th>
              {/* {screenshotsEnabled && <th className="screenshots-header">Screenshots</th>} */}
              {/* {deviceReportEnabled && <th>Reports</th>} */}
              {/* {rebootEnabled && <th>Reboot</th>} */}
              {offlineEnabled && <th>Offline</th>}
              {delayDownloadEnabled && <th>Device State</th>}
              <th>Last Ping</th>
              {
                profile != undefined && profile.profile.package.device_tags?
                  <th>Device Tags</th>
                : null
              }
              
              <th>Device Options</th>
              <th>Change Group</th>
            </tr>
              :
              offlineOnly === 'false' ?
              <tr className="list-headings depth-1">
                <th>Device Name</th>
                {/* {screenshotsEnabled && <th className="screenshots-header">Screenshots</th>} */}
                {/* {deviceReportEnabled && <th>Reports</th>} */}
                {/* {rebootEnabled && <th>Reboot</th>} */}
                {offlineEnabled && <th>Offline</th>}
                {delayDownloadEnabled && <th>Device State</th>}
                <th>Last Ping</th>
                {
                  profile != undefined && profile.profile.package.device_tags?
                    <th>Device Tags</th>
                  : null
                }
                <th>Device Options</th>
                <th>Change Group</th>
              </tr>
              :
              <tr className="list-headings depth-1">
                <th>Device Name</th>
                
                <th>Change Group</th>
              </tr>
          }
            
            
          </thead>
          <tbody className={this.state.showDevices ? 'device-table' : 'hide-device-table'}>
            {showSearchBox && <Box
              direction="row" justifyContent="center" alignItems="center"
            >
              <input
                className='text-input'
                type="search"
                name="search-form"
                id="search-form"
                placeholder="Search a device"
                value={searchInput}
                onChange={(e) => this.searchItems(e.target.value)} />




            </Box>}



            {searchInput.length > 1 ? (
              filteredDevices.map((device, index) =>{ 
              if(!(index > rowNumber - 1)){
              return(
                <DeviceView key={device.device_id}
                  deviceReportEnabled={deviceReportEnabled}
                  rebootEnabled={rebootEnabled}
                  RestartAppEnabled={RestartAppEnabled}
                  ClearUnusedMediaEnabled={ClearUnusedMediaEnabled}
                  offlineEnabled={offlineEnabled}
                  delayDownloadEnabled={delayDownloadEnabled}
                  screenshotsEnabled={screenshotsEnabled}
                  device={device}
                  reportCall={downloadReport}
                  onChange={onDeviceChange}
                  groupList={groupsOptionData}
                  rebootDevice={this.rebootDevice.bind(this)}
                  RestartApp={this.RestartApp.bind(this)}
                  ClearUnusedMedia={this.ClearUnusedMedia.bind(this)}
                  ShowDeviceInfo={this.ShowDeviceInfo}
                  deviceTags={this.props.deviceTags}
                />

              )}})
            ) : (deviceGroup && devices.map((device, index) => {
              if(!(index > rowNumber - 1)){
              return (
                <DeviceView key={device.device_id}
                  deviceReportEnabled={deviceReportEnabled}
                  rebootEnabled={rebootEnabled}
                  RestartAppEnabled={RestartAppEnabled}
                  ClearUnusedMediaEnabled={ClearUnusedMediaEnabled}
                  offlineEnabled={offlineEnabled}
                  delayDownloadEnabled={delayDownloadEnabled}
                  screenshotsEnabled={screenshotsEnabled}
                  device={device}
                  reportCall={downloadReport}
                  onChange={onDeviceChange}
                  groupList={groupsOptionData}
                  rebootDevice={this.rebootDevice.bind(this)}
                  RestartApp={this.RestartApp.bind(this)}
                  ShowDeviceInfo={this.ShowDeviceInfo.bind(this)}
                  ClearUnusedMedia={this.ClearUnusedMedia.bind(this)}
                  deviceTags={this.props.deviceTags}
                />
              )}}))}


          </tbody>
        </table>
        {
          
          !(filteredPages !== 0 && searchInput.length > 1) ?
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >

          
            <div>
              {rowNumbers().length > 1 ?  
              <select defaultValue={rowNumber} onChange={handleRows}>
                {rowNumbers()}
              </select>
              :
              ''}
            </div>
            <div>
              Page {pageNumber} of {pages}
              <i 
                className="fas fa-angle-left" 
                style={{marginRight: '20px', marginLeft: '35px', cursor: 'pointer'}}
                onClick={() => {
                  (pageNumber > 1) && this.setState({ pageNumber: pageNumber - 1 })
                }}
                ></i>
              <i 
                className="fas fa-angle-right" 
                style={{marginRight: '20px',cursor: 'pointer'}}
                onClick={() => {
                  !(pageNumber >= pages) && this.setState({ pageNumber: pageNumber + 1 })
                }}
                ></i>
            </div>
          </div>

          :
          
          pages !== 0 &&
          
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >

          
            <div>
              {filteredRowNumbers().length > 1 ?  
              <select defaultValue={filteredRowNumbers()[0]} onChange={handleRows}>
                {filteredRowNumbers()}
              </select>
              :
              ''}
            </div>
            <div>
              Page {pageNumber} of {filteredPages}
              <i 
                className="fas fa-angle-left" 
                style={{marginRight: '20px', marginLeft: '35px', cursor: 'pointer'}}
                onClick={() => {
                  (pageNumber > 1) && this.setState({ pageNumber: pageNumber - 1 })
                }}
                ></i>
              <i 
                className="fas fa-angle-right" 
                style={{marginRight: '20px',cursor: 'pointer'}}
                onClick={() => {
                  !(pageNumber >= filteredPages) && this.setState({ pageNumber: pageNumber + 1 })
                }}
                ></i>
            </div>
          </div>}
      
      </Box >
    );
  }
}

const mapStateToProps = state => {
  return {
    profile: getProfile(state),
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    confirmationRequest: (title, message, operation, resourceType, id) => dispatch(confirmationRequest(
      title, message, operation, resourceType, id
    )),
    fetchDeviceGroups: (groupId) => dispatch(fetchDeviceGroups(groupId)),
    fetchSingleDeviceGroups: (groupId) => dispatch(fetchSingleDeviceGroups(groupId)),
    downloadReport: (deviceID) => dispatch(downloadReport(deviceID)),
    toggleDeviceId: (id) => dispatch(toggleDeviceId(id)),
    updateDeviceGroup: (id, data) => dispatch(updateDeviceGroup(id, data))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(DeviceGroupView);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/DeviceGroupView/index.js